var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41093 13.6044C5.28638 13.6044 5.16182 13.5585 5.06348 13.4602C4.87337 13.2701 4.87337 12.9554 5.06348 12.7653L14.2414 3.58741C14.4315 3.3973 14.7461 3.3973 14.9363 3.58741C15.1264 3.77752 15.1264 4.09219 14.9363 4.28231L5.75838 13.4602C5.66005 13.5585 5.53549 13.6044 5.41093 13.6044Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1437 13.6052H5.41111C5.14233 13.6052 4.91943 13.3823 4.91943 13.1135V6.38083C4.91943 6.11205 5.14233 5.88916 5.41111 5.88916C5.67989 5.88916 5.90278 6.11205 5.90278 6.38083V12.6218H12.1437C12.4125 12.6218 12.6354 12.8447 12.6354 13.1135C12.6354 13.3823 12.4125 13.6052 12.1437 13.6052Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5723 16.5546H4.42771C4.15893 16.5546 3.93604 16.3317 3.93604 16.063C3.93604 15.7942 4.15893 15.5713 4.42771 15.5713H15.5723C15.8411 15.5713 16.064 15.7942 16.064 16.063C16.064 16.3317 15.8411 16.5546 15.5723 16.5546Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveIcon);
export default __webpack_public_path__ + "static/media/receive-icon.33e01a9f4ae78a661d72a5df80a38de8.svg";
export { ForwardRef as ReactComponent };